import * as React from "react";

// icons
import "font-awesome/css/font-awesome.min.css";

// styling
import "bootstrap/dist/css/bootstrap.min.css";
import "./assessmentViewPage.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

// services
import {
  createItemGen,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
  setProfileData
} from "../../common/services";

// interfaces
import { IAssessmentAnswer } from "../../common/interfaces";

// components
import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";

// assessment components
import QuestionCollection from "../../common/questionCollection.Component";
import ProgressBar from "../../common/progressBar.Component";

// router
import { Redirect } from "react-router-dom";

// components
import assessmentIcon from "../../assets/images/assessment-icon.svg";
// toast component
import { toast, ToastContainer } from "react-toastify";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import CustomCheckbox from "src/common/CustomCheckbox";

export interface Istate {
  activeStep: number;
  classes: any;
  theme: any;
}

class AssessmentPreviewPage extends React.Component<Istate, any> {
  public state = {
    answer: "",
    answerOptions: [],
    assessment: {},
    assessmentfields: {
      info: "assessment_info",
      questions: "questions",
      session: "assessment_session"
    },
    assessmenttitle: "",
    baseurl: currentBaseUrl(),
    counter: 0,
    currentTimeon: 0,
    destination: '',
    interactions: 0,
    navigate: false,
    loaded: false,
    question: "",
    questionId: 1,
    questiontime: new Date().getTime(),
    responses: [] as IAssessmentAnswer[],
    result: "",
    timetaken: 0,
    tocompleted: false,
    todashboard: false,
    tologin: false,
    toProfile: false,
    total: 0,
    submitconfirmed: false
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.setUserAnswer = this.setUserAnswer.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.increaseCounterClearAns = this.increaseCounterClearAns.bind(this);
    this.loadQuestion = this.loadQuestion.bind(this);
    this.submitAnswers = this.submitAnswers.bind(this);
    this.onProfile = this.onProfile.bind(this);
    this.confirmSubmit = this.confirmSubmit.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.prevButton = this.prevButton.bind(this);
    this.prevQuestion = this.prevQuestion.bind(this);
  }

  public onLogout(arg) {
    console.log("Logout in Parent", arg);
    this.setState({ tologin: true });
  }

  public onGoBack() {
    const dest = currentBaseUrl() + 'singleassessment/' + this.currentid();
    
    console.log(dest);
    
    this.setState({
        navigate: true,
        destination: dest
    })
}

  public onProfile() {
    this.setState({ toProfile: true });
  }

  public currentid() {
    const key1 = "match";
    console.info("THIS>PROPS" + JSON.stringify(this.props, null, 4))
    return this.props[key1].params.id;
  }

  public handleGenSmartDataLoaded(res) {
    if (res.code === 200) {
      console.log(res.response);
      this.setState({ loaded: true });
      this.setState({ assessment: res.response });
      this.loadQuestion();
    }

    if (res.code === 401) {
      this.onLogout("arg");
    }
  }

  public handleGenCreatedItemLoaded(res) {
    if (res.code === 200) {
      toast.success("Request successful");

      this.setState({ loaded: true });

      console.log(res.response.profile);

      setProfileData(res.response.profile);

      this.setState({ tocompleted: true });
    }

    if (res.code === 404) {
      toast.error("Request failed, try again");
      this.setState({ loaded: false });
    }

    if (res.code === 401) {
      toast.success("Request unauthorized");
      this.onLogout("arg");
    }
  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {
      getGeneralSmartTableData(
        "admin/assessments/" + this.currentid() + "/assessment_preview/",
        text => this.handleGenSmartDataLoaded(text)
      );
    }
  }

  public handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);
  }
  public confirmSubmit() {
    console.log("SUBMIT CONFIRM" + this.state.submitconfirmed);
    this.setState(prevState => ({
      submitconfirmed: !prevState.submitconfirmed
    }));
  }
  public submitAnswers() {
    this.generateResponse();

    const qnCount = this.state.assessment[this.state.assessmentfields.questions].length;

    const responseCol = [] as any;

    for (let i=0; i < qnCount; i++) {

      const key = "ans_qn_" + i;

      const qnItem = sessionStorage.getItem(key) || null;

      if (qnItem) {
        responseCol.push(qnItem);
        sessionStorage.removeItem(key)
      }
    }

    toast.success("Answers submitted!");

    console.log(responseCol);

    setTimeout(this.onGoBack, 3000);  

  }

  public setUserAnswer(answer) {
    console.log(answer);
    const newinteractioncount = this.state.interactions + 1;
    this.setState({
      answer: answer + "",
      interactions: newinteractioncount
    });    
  }

  public increaseCounterClearAns() {
    const newcount = this.state.counter + 1;
    this.setState({
      answer: "",
      counter: newcount
    });
  }

  public decreaseCounterClearAns() {
    const newcount = this.state.counter - 1;
    this.setState({
      answer: "",
      counter: newcount
    });
  }

  public loadQuestion() {

    const key = "ans_qn_" + this.state.counter;

    const existing = sessionStorage.getItem(key) || null;

    let interactions = 0;

    let answer = "";

    let currentTimeon = 0;

    if (existing) {

      try {
        const value = JSON.parse(existing);
        
        answer = value.answer;
        interactions = value.interactions;
        currentTimeon = value.timeon

      } catch (e) {
        console.log('err reading saved ans')
      }
    }
    
    this.setState({
      answerOptions: this.state.assessment[
        this.state.assessmentfields.questions
      ][this.state.counter].answers,
      assessmenttitle: this.state.assessment[this.state.assessmentfields.info]
        .Title,
      interactions,
      answer,
      currentTimeon,
      question: this.state.assessment[this.state.assessmentfields.questions][
        this.state.counter
      ].Question,
      questionId: this.state.assessment[this.state.assessmentfields.questions][
        this.state.counter
      ].id,
      questiontime: new Date().getTime(),
      total: this.state.assessment[this.state.assessmentfields.questions].length
    });
  }

  public generateResponse() {
    const timespent = Math.floor(
      ((new Date().getTime() - this.state.questiontime) % (1000 * 60)) / 1000
    ) + this.state.currentTimeon;
    
    const key = "ans_qn_" + this.state.counter

    const val = {
      answer: this.state.answer,
      answeredtime: new Date().getTime(),
      interactions: this.state.interactions,
      question: this.state.questionId,
      timeon: timespent
    }

    sessionStorage[key] = JSON.stringify(val)
  }

  public nextQuestion() {
    if (
      this.state.counter <
      this.state.assessment[this.state.assessmentfields.questions].length
    ) {
      
      this.generateResponse()

      this.increaseCounterClearAns();
      setTimeout(() => this.loadQuestion(), 300);

    } else {
      console.log("end of list");
      // route to assessment complete page uncomment the line below
      // commented to sort the routing btn upgraded, preupgrade and lessonAssessmentResults
      this.setState({ tocompleted: true });
    }
  }

  public prevQuestion() {
    if (
      this.state.counter > 0
    ) {
      
      console.log(this.state.responses);
      this.decreaseCounterClearAns();
      setTimeout(() => this.loadQuestion(), 300);

    }
  }

  public nextButton() {
    if (this.state.assessment[this.state.assessmentfields.questions]) {
      if (
        this.state.counter <
        this.state.assessment[this.state.assessmentfields.questions].length - 1
      ) {
        return (
          <button
            className="next-button"
            disabled={this.state.answer.length < 1}
            onClick={this.nextQuestion}
          >
            Next Question
          </button>
        );
      } else {
        return (
          <React.Fragment>
            <CustomCheckbox
              dispvalue="Are you 100% happy with yout answers? If so, great work, click the button"
              id="confirm-submit"
              type="checkbox"
              name="confirm"
              onChange={this.confirmSubmit}
            />
            
          <button
              className="next-button"
              disabled={
                this.state.answer.length < 1 ||
                this.state.submitconfirmed === false
              }
              onClick={this.submitAnswers}
            >
              Submit
            </button>
          </React.Fragment>
          
        );
      }
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <h2>Assessment not found</h2>
          <i className="fa fa-frown-o" style={{ fontSize: 300 }} />
          <p>
            This assessment does not exist please go{" "}
            <a href={this.state.baseurl + "home"}>Home</a> and try again
          </p>
        </div>
      );
    }
  }

  public prevButton() {
    if (this.state.assessment[this.state.assessmentfields.questions]) {
      if (
        this.state.counter > 0
      ) {
        return (
          <button
            className="next-button"
            onClick={this.prevQuestion}
          >
            Previous Question
          </button>
        );
      } else {
        return (
          ""
        );
      }
    } else {
      return (
        ""
      );
    }
  }

  public render() {
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (this.state.toProfile === true) {
      return <Redirect to={this.state.baseurl + "profile"} />;
    }

    if (this.state.todashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }

    if (this.state.tocompleted === true) {
      return (
        <Redirect
          to={this.state.baseurl + "assessmentcompleted/" + this.currentid()}
        />
      );
    }

    const Styles = {
      toast: {
        zIndex: 9999999
      },
      welcometext: {
        margin: 0,
        marginTop: "2%"
      }
    };
    return (
      <div>
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <ToastContainer style={Styles.toast} />
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="assessment-main-container">
            <Loader
              loaded={this.state.loaded}
              style={{ width: "80%", overflowY: "scroll" }}
            >
              <div className="assessment-wrapper">
                <h2 className="assessment-title">
                  {this.state.assessmenttitle}
                </h2>
                <div className="breadcrumb-progress-bar">
                  {/*<p className="go-back"> &lt; Back </p>*/}
                  <ProgressBar
                    fraction={this.state.counter}
                    total={this.state.total}
                    showLabel={true}
                  />
                </div>

                <div className="questions-container">
                  <div className="assessment-thumb">
                    <img src={assessmentIcon} alt="Icon of stationery" />
                  </div>
                  <QuestionCollection
                    answer={this.state.answer}
                    answerOptions={this.state.answerOptions}
                    questionId={this.state.questionId}
                    question={this.state.question}
                    questionTotal={this.state.total}
                    onAnswerSelected={this.handleAnswerSelected}
                    // prop for number of current qn
                    currentQuestion={this.state.counter + 1}
                  />
                </div>
              </div>
            </Loader>
    <footer className="assessment-footer"> {this.prevButton()} {this.nextButton()} <button onClick={this.onGoBack}> To Edit</button></footer>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default AssessmentPreviewPage;



// WEBPACK FOOTER //
// ./src/pages/Assessments/assessmentPreviewPage.Component.tsx